import {MessageDescriptor} from 'react-intl';

import validationRules from 'coreUtils/validationRules';

import messages from './messages';

const rules = {
	firstName: [
		{
			rule: validationRules.isRequired,
			errorMessage: messages.latinCharactersError,
		},
		{
			rule: validationRules.validateCustomerName,
			errorMessage: messages.latinCharactersError,
		},
		{
			rule: validationRules.noNumbers,
			errorMessage: messages.noNumbers,
		},
		{
			rule: validationRules.hasCorrectLength(2),
			errorMessage: messages.minLength,
		},
		{
			rule: validationRules.noSpecialChars,
			errorMessage: messages.noSpecialChars,
		},
	],
	lastName: [
		{
			rule: validationRules.isRequired,
			errorMessage: messages.latinCharactersError,
		},
		{
			rule: validationRules.validateCustomerName,
			errorMessage: messages.latinCharactersError,
		},
		{
			rule: validationRules.noNumbers,
			errorMessage: messages.noNumbers,
		},
		{
			rule: validationRules.hasCorrectLength(2),
			errorMessage: messages.minLength,
		},
		{
			rule: validationRules.noSpecialChars,
			errorMessage: messages.noSpecialChars,
		},
	],
	email: [
		{
			rule: validationRules.isRequired,
			errorMessage: messages.latinCharactersError,
		},
		{
			rule: validationRules.validateCustomerName,
			errorMessage: messages.latinCharactersError,
		},
		{
			rule: validationRules.isRequired,
			errorMessage: messages.emailNotFound,
		},
		{
			rule: validationRules.isEmail,
			errorMessage: messages.emailIsInvalid,
		},
	],
	password: [
		// Additional password rules are applied in the component.
		{
			rule: validationRules.isRequired,
			errorMessage: messages.passwordNotFound,
		},
	],
	birthday: [
		{
			rule: validationRules.isBirthday,
			errorMessage: messages.birthdayIsInvalid,
		},
	],
};

const verify = (value, validation) => (validation.rule(value) ? null : validation.errorMessage);

const firstErrorFor = (value) => (error, validation) => error || verify(value, validation);

const validate = (values: Record<string, any>): Record<string, MessageDescriptor> => {
	const check_birtday = values.birthday && Object.values(values.birthday).every((value) => !!value);

	const matches = [
		['email', rules.email.reduce(firstErrorFor(values.email), null)],
		['password', rules.password.reduce(firstErrorFor(values.password), null)],
		['birthday', check_birtday ? rules.birthday.reduce(firstErrorFor(values.birthday), null) : null],
	];

	return Object.fromEntries(matches.filter((match) => !!match[1]));
};

export default {rules, validate};
